import React, { useState } from "react";
import ProfileForm from "./ProfileForm";
import ChangePasswordForm from "./ChangePasswordForm";
import { User, Lock, Settings } from "lucide-react";

const ProfileTabs = () => {
  const [activeTab, setActiveTab] = useState("profile");

  const tabs = [
    { id: "profile", label: "Profile Information", icon: <User size={18} /> },
    { id: "password", label: "Change Password", icon: <Lock size={18} /> },
  ];

  return (
    <div className=" w-100  rounded-lg  overflow-hidden mx-auto ">

      {/* TABS Navigation */}
      <div className="flex border-b border-gray-100 bg-gray-70/50">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={` flex items-center justify-center space-x-2 px-4 py-5 text-sm font-bold transition-all relative overflow-hidden group ${activeTab === tab.id
                ? "text-[#00B8D9]"
                : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
              }`}
          >
            <span className={`transition-transform duration-300 ${activeTab === tab.id ? "scale-110" : "group-hover:scale-105"}`}>
              {tab.icon}
            </span>
            <span>{tab.label}</span>
            {activeTab === tab.id && (
              <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#00B8D9] rounded-t-full shadow-[0_-2px_6px_rgba(0,184,217,0.4)]" />
            )}
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="p-6 sm:p-10 mb-2 bg-white">
        {activeTab === "profile" ? <ProfileForm /> : <ChangePasswordForm />}
      </div>
    </div>
  );
};

export default ProfileTabs;
